<template>
  <div :class="`form-element form-${type}-element`">
    <template v-if="options.recording">
      <FormLabel
        :required="options.required"
        :title="options.title"
        :filled="internalValue !== undefined && internalValue !== null"
        :field-type="type"
      />
      <v-row no-gutters>
        <v-col>
          <v-btn
            v-if="!isRecording"
            class="mr-3"
            fab
            @click="startRecording"
          >
            <v-icon>mdi-record</v-icon>
          </v-btn>
          <v-btn
            v-if="isRecording"
            class="mr-3"
            fab
            @click="pauseRecording"
          >
            <v-icon v-if="!isPaused">
              mdi-pause
            </v-icon>
            <v-icon v-else>
              mdi-play
            </v-icon>
          </v-btn>
          <v-btn
            v-if="isRecording"
            class="mr-3"
            fab
            @click="stopRecording"
          >
            <v-icon>mdi-stop</v-icon>
          </v-btn>
          <span
            v-if="isRecording"
            class="record-time"
          >{{ recordTime }}</span>
          <v-btn
            v-if="recording || file"
            icon
            @click="resetRecording"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <audio
            v-show="recording || file"
            ref="player"
          />
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-file-input
        v-model="file"
        :label="options.title"
        prepend-icon="mdi-microphone"
        accept="audio/*"
        :required="options.required"
        hide-details>
        <template v-slot:label>
          <FormLabel
            input-label
            :required="options.required"
            :title="options.title"
            :filled="internalValue !== undefined && internalValue !== null"
            :field-type="type"
          />
        </template>
      </v-file-input>
    </template>
  </div>
</template>

<script>
import Recorder from '@/lib/recorder';
import RecorderNative from '@/lib/recorder-native';
import FormLabel from '../FormLabel';
import { convertTimeMMSS } from '@/lib/utils';
import moment from 'moment';

export default {
  components: {
    FormLabel
  },
  props: {
    value: { type: [File, Object], default () { return null; } },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data: () => ({
    file: null,
    currentFileSet: false,
    recording: null,
    recorder: null,
    audioStream: null
  }),
  computed: {
    recordTime () {
      return convertTimeMMSS(this.recorder.duration);
    },
    isPaused () {
      return this.recorder && this.recorder.isPaused;
    },
    isRecording () {
      return this.recorder && this.recorder.isRecording;
    },
    internalValue: {
      get () {
        return this.value;
      },
      set (v) {
        this.$emit('input', v);
      }
    }
  },
  watch: {
    internalValue: {
      immediate: true,
      handler: async function (v) {
        if (!this.file && v) {
          this.currentFileSet = true;
          this.file = { name: v.name };

          this.$nextTick().then(() => {
            if (this.$refs.player && v.file_url) {
              this.$refs.player.src = v.file_url;
              this.$refs.player.controls = true;
            }
          });
        }
      }
    },
    async file (file) {
      if (this.currentFileSet) {
        this.currentFileSet = false;
        return;
      }
      if (file instanceof Array) {
        file = file[0];
      }

      if (!file) {
        this.internalValue = null;
        return;
      }

      if (global.isWeb) {
        const ab = await file.arrayBuffer();
        this.internalValue = {
          blob: new Blob([ab], { type: file.type }),
          name: file.name
        };
      } else {
        this.internalValue = file;
      }
    }
  },
  methods: {
    startRecording () {
      if (!global.isWeb) {
        this.recorder = new RecorderNative();
      } else {
        this.recorder = new Recorder();
      }

      this.recorder.start();
    },
    pauseRecording () {
      if (!this.recorder || !this.recorder.isRecording) { return; }

      if (this.recorder.isPause) {
        this.recorder.start();
      } else {
        this.recorder.pause();
      }
    },
    async stopRecording () {
      await this.recorder.stop();
      this.recording = this.recorder.lastRecord();

      this.file = {
        blob: this.recording.blob,
        name: moment().format('YYYY-MM-DD hh:mm:ss') + '.mp3'
      };
      this.$refs.player.src = this.recording.url;
      this.$refs.player.controls = true;
    },
    resetRecording () {
      this.recording = null;
      this.file = null;
      this.internalValue = null;
    }
  }
};
</script>
